import { render } from "./SongDetails.vue?vue&type=template&id=887f69a4"
import script from "./SongDetails.vue?vue&type=script&lang=js"
export * from "./SongDetails.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__